import { createElement } from 'react';
import { bD as __rest, bE as __assign } from './index.esm-47de5464.js';
import 'react-measure';
import 'react-router-dom';
import 'react-dom';
import 'throttle-debounce';
import 'focus-trap-react';
import 'react-swipeable';
import 'react-animate-height';
import 'country-flag-emoji-polyfill';
import 'intersection-observer';
import 'html-react-parser';

var SvgComponent = function SvgComponent(_a) {
  var title = _a.title,
    props = __rest(_a, ["title"]);
  return /*#__PURE__*/createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    focusable: "false"
  }, props), title ? /*#__PURE__*/createElement("title", null, title) : null, /*#__PURE__*/createElement("path", {
    d: "M11 16.414L6.04999 11.465L7.46399 10.051L11 13.586L17.364 7.22205L18.778 8.63605L11 16.414Z"
  }));
};

export default SvgComponent;
